import { createSlice } from "@reduxjs/toolkit";
import { getGlobalConfig } from "../services/globalConfig";

interface GlobalConfigState {
  globalConfigStatus: string;
  globalConfigUi: unknown[];
}

const initialState: GlobalConfigState = {
  globalConfigStatus: "idle",
  globalConfigUi: [],
};

const globalConfigSlice = createSlice({
  name: "globalConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGlobalConfig.pending, (state) => {
        state.globalConfigStatus = "pending";
      })
      .addCase(getGlobalConfig.fulfilled, (state, action) => {
        const payload = action.payload as { data: { config: unknown[] } };
        state.globalConfigStatus = "success";
        state.globalConfigUi = payload.data.config;
      })
      .addCase(getGlobalConfig.rejected, (state) => {
        state.globalConfigStatus = "rejected";
      });
  },
});

export default globalConfigSlice.reducer;
